import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { SpotFillRateLineChart } from '@frontend/chart/components';
import { Chart, ChartBinSize, ChartQueryParam } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';
import { useEffect, useState } from 'react';

import { getLast30DaysChartRange } from '../last-30-days-chart-range';
import { Last30DaysPudoSpotFillRateLineChartProps } from './last-30-days-pudo-spot-fill-rate-line-chart.component';

export const useLast30DaysPudoSpotFillRateLineChart = (props: Last30DaysPudoSpotFillRateLineChartProps) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const application = props.application ?? Application.PUDO;
    const feature = props.feature;

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = getLast30DaysChartRange();

        // Absolute occupied SLOT counts (default data_mode) so values share the same scale as
        // `reference` (PuDo / SLOT capacity). Percentage mode returns 0–100 while capacity stays absolute.
        ChartClient.fetchChartData(props.accountId, SpotFillRateLineChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            [ChartQueryParam.BIN_SIZE]: ChartBinSize.DAY,
            [ChartQueryParam.APPLICATION]: application,
            ...(feature ? { [ChartQueryParam.FEATURE]: feature } : {})
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId, application, feature]);

    return {
        data,
        isLoading,
        navigateUrl: props.navigateUrl
    };
};
